module.exports = "/fonts/FiraSans-Regular.ttf";